<!--
  This is a temporary component to display the affected system items in a test page.
-->
<template>
  <ul v-if="items && items.length > 0">
    <li v-for="item in items" :key="item.fields.name">
      <div>Key: <sc-text :field="item.fields.key" /></div>
      <div>Owner: <sc-text :field="item.fields.owner" /></div>
    </li>
  </ul>
</template>

<script>
import { Text } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-Advisory-RelatedControl',
  props: {
    items: {
      type: Array
    }
  },
  components: {
    ScText: Text
  }
};
</script>
